import { Browser } from '../utils/browsercheck';
import * as MenuUtil from '../utils/menu';

/**
 * Menu component
 *
 * Funktionen für das Hauptmenü (Desktop und Mobile).
 */

/**
 * @typedef {Object} MenuOptions
 * @property {number} breakPoint
 * @property {string} selector
 * @property {string} navButton
 * @property {number} levels
 * @property {() => boolean} inMobileMode
 */
export const Menu = {
    breakPoint: 992,
    selector: '.main-nav',
    navButton: 'header .nav-button',
    levels: 3,

    inMobileMode: () => $(window).width() < Menu.breakPoint,
};

function init() {
    const $mainNav = $(Menu.selector);

    if (!Menu.inMobileMode() && !Browser.isTouchDevice) {
        // Fix für Fehler beim Öffnen mit der Maus (brauchen wir das noch?)
        $mainNav.find('.level_1 > li.submenu').one('mousemove', function () {
            $(this).find('.level_2').stop().slideDown('fast');
            $(this).children('a').addClass('open');
        });
    }

    // HoverMenu Funktion für alle Levels registrieren
    for (let i = 1; i < Menu.levels; i++) {
        $mainNav.find(`.level_${i} > li.submenu`).hoverMenu(i + 1);
    }

    if (Menu.inMobileMode()) {
        // In der mobilen Ansicht das aktive Level öffnen
        MenuUtil.openActiveLevel(Menu.selector);
    }
}

function useSlideDownMenu() {
    // Slide down the main navigation
    $(Menu.navButton).on('click', function () {
        $(this).next(Menu.selector).slideToggle('500');
        $(this).toggleClass('active');
    });
}

// eslint-disable-next-line no-unused-vars
function useOverlayMenu() {
    // Open the navigation overlay
    $(Menu.navButton).on('click', function () {
        $('#nav-overlay').fadeIn(300);
    });

    // Close the navigation overlay
    $('#nav-close').on('click', function () {
        $('#nav-overlay').fadeOut(300);
    });
}

function closeMenuAfterClick() {
    // bei Onepagern das Burger-Menü nach Link-Klick gleich wieder schließen
    $(`#header ${Menu.selector} a`).on('click', function (el) {
        if (!Menu.inMobileMode()) {
            return;
        }

        if (el.target.hash && el.target.pathname == window.location.pathname) {
            $(Menu.selector).slideUp('500');
            $(Menu.navButton).removeClass('active');
        }
    });
}

$(function () {
    MenuUtil.registerjQueryHoverMenu(Menu);

    init();

    useSlideDownMenu();
    // useOverlayMenu();

    // if (Browser.isOnePage) {
    closeMenuAfterClick();
    // }
});

$(window).on('resize', function () {
    if (Menu.inMobileMode()) {
        // Aktives Level öffnen beim Wechsel zur mobilen Ansicht
        MenuUtil.openActiveLevel(Menu.selector);
    } else {
        // Mobiles Menü beim Wechsel zur Desktop-Ansicht zurücksetzen
        MenuUtil.resetMobileMenu(Menu);
    }
});
